"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _UsageStore = _interopRequireDefault(require("./UsageStore2"));

var UsageActions = /*#__PURE__*/function () {
  function UsageActions() {
    (0, _classCallCheck2["default"])(this, UsageActions);
  }

  (0, _createClass2["default"])(UsageActions, null, [{
    key: "receiveChangesCompleted",
    value: function receiveChangesCompleted(message) {
      _UsageStore["default"].receiveChangesCompleted(message);
    }
  }, {
    key: "receiveChangesFailed",
    value: function receiveChangesFailed(message) {
      _UsageStore["default"].receiveChangesFailed(message);
    }
  }]);
  return UsageActions;
}();

var _default = UsageActions;
exports["default"] = _default;